import React from "react";

// Constants and Utils
import { toStringWithRoundUp } from "../../../common-utils/number-utils/NumberUtils";

// Component
export default function Population({ population }) {
  // rounded up population with locale string formatting
  const populationValue = population ? toStringWithRoundUp(population) : "--";

  return (
    <p>
      <strong>{"Population: "}</strong>
      <span>
        <b>{populationValue}</b>
        {" as of 2025"}
      </span>
    </p>
  );
}
